const state = {
  itemNumber: 3,
  items: [],
  currentSeq: null,
  defaultItem: null,
  selectedItem: null
}

const getters = {
  getItems: state => state.items,
  getDefaultItem: state => state.defaultItem,
  getCurrentSeq: state => state.currentSeq,
  getItemNumber: state => state.itemNumber,
  getSelectedItem: state => state.selectedItem
}

const mutations = {
  setItems (state, items) {
    state.items = items
    state.defaultItem = items.find(item => parseInt(item.defFlg)) || null
  },
  setCurrentSeq (state, seq) {
    state.currentSeq = seq
  },
  setDefaultItem (state, item) {
    state.defaultItem = item
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/scshippingmultichannelinfo.js